<div [attr.hidden]="iframeLoaded ? null : true"
     id="div_container_iframe_app" *ngIf="isLogged">
  <iframe
    title="apps"
    id="iframe_apps"
    class="iframe-apps"
    [height]="iframeHeight"
    (load)="onIframeLoad()"
    [src]="urlIframe">
  </iframe>
</div>

<!-- <div class="surface-ground px-4 mt-5 md:px-6" id="div_container_cards_apps" *ngIf="!iframeLoaded">
  <div class="flex justify-content-around">
    <div *ngFor="let app of apps"
        style="max-width: 33%;"
        [ngClass]="{'cursor-pointer': !app.disabled, 'app-disabled': app.disabled}"
        (click)="handleSelect(app)"
        class="shadow-2 surface-card border-round mr-0 xl:mr-0 mb-6 xl:mb-0 flex-column md:flex-row">
      <p-galleria
        [value]="app.imgs ?? []"
        [numVisible]="5"
        [circular]="true"
        [autoPlay]="true"
        [showIndicators]="false"
        [showItemNavigatorsOnHover]="false"
        [showItemNavigators]="false"
        [showThumbnails]="false"
        [containerStyle]="{ 'max-height': '300px' }">
        <ng-template pTemplate="item" let-item>
          <img [src]="item" class="border-round m-2"
               alt="aplicativo"
               style="max-height: 300px; max-width: 100%;"/>
        </ng-template>
      </p-galleria>
      <div class="pl-3 p-2 pt-4">
        <div class="flex justify-content-center mb-3">
          <span class="text-orange-500 text-lg font-medium"
                style="color: #0449a0 !important;">
            {{ app.name }}
          </span>
        </div>
        <div *ngIf="false" class="font-medium text-lg text-900 mb-3 line-height-3">
          {{ app.descricao }}
        </div>
        <div *ngIf="false" class="line-height-3 text-700 mb-3">
          {{ app.resumo }}
        </div>
        <div *ngIf="false" class="flex align-items-center w-full">
          <p-avatar image="assets/images/velsinho/Pose%205%20com%20sombra.png"
                    shape="circle" class="p-element">
          </p-avatar>
          <span class="font-bold text-sm block ml-2 text-blue-600">
            Flow
          </span>
          <div class="flex justify-content-end w-full">
            <p-badge severity="warning"
                     value="MÓDULO NÃO HABILITADO"
                     *ngIf="app.disabled">
            </p-badge>
          </div>
        </div>
      </div>
    </div>
  </div>
</div> -->
<div class="surface-ground px-4 mt-5 md:px-6" id="div_container_cards_apps" *ngIf="!iframeLoaded">
  <div class="grid">
    <ng-container *ngFor="let app of apps">
      <div
        *ngIf="isVelser(app?.id) && isAdm(app?.id)"
        class="col-4 px-4"
        [ngClass]="{'grayscale': app.disabled}">
        <div
          style="background-image: url({{app.background}});"
          class="card h-19rem shadow-2 border-round mr-0 xl:mr-0 mb-6 xl:mb-0"
          >
            <div class="card-content h-full flex flex-column align-items-center justify-content-center">
              <img
                *ngIf="app.logo"
                style="width: 50%;"
                class="my-4 logo-transform"
                [class.opacity-30]="app.disabled"
                [src]="app.logo">

                <p *ngIf="!app.logo" class="absolute mb-8 text-3xl text-white">{{app.name}}</p>

              <button
                [disabled]="app.disabled"
                (click)="app.disabled ? '' : handleSelect(app)"
                [ngClass]="{'cursor-not-allowed': app.disabled}"
                class="custom-btn my-4">
                {{app.disabled ? 'Sem Acesso' : 'Entrar'}}
              </button>
            </div>
        </div>
      </div>
    </ng-container>
  </div>
</div>
